export default "__VITE_ASSET__Be7mec8H__"